import React from 'react';
import { Typography } from '@mui/material';
import { GivelifyLabelProps } from './types';

export const GivelifyLabel: React.FCC<GivelifyLabelProps> = ({
    text,
    variant = 'body1',
    bold,
    children,
    wrap,
    wordBreak,
    fontWeight,
    ...props
}) => {
    return (
        <Typography
            {...props}
            fontWeight={bold ? 'bold' : fontWeight}
            noWrap={props.noWrap ?? (wrap !== undefined ? !wrap : undefined)}
            sx={{
                ...props.sx,
                ...(wordBreak && { wordBreak: 'break-word' }),
            }}
            variant={variant}
            variantMapping={{
                heading1: 'h1',
                heading2: 'h2',
                heading3: 'h3',
                heading1M: 'h1',
                heading2M: 'h2',
                heading3M: 'h3',
                heading1S: 'h1',
                heading2S: 'h2',
                heading3S: 'h3',
                caption1: 'div',
                caption2: 'div',
                h1legacy: 'h1',
                h2legacy: 'h2',
                h3legacy: 'h3',
                h4legacy: 'h4',
                h5legacy: 'h5',
                body1: 'p',
                body2: 'p',
                body1B: 'p',
                body2B: 'p',
            }}
        >
            {children ? children : text}
        </Typography>
    );
};
